import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "className", "mode", "size", "allOption", "allSelectedMessage", "customLabelKey", "customValueKey", "someSelectedMessage", "hasTruncation", "hideSelectedOptions", "isAsync", "isCreatable", "isDisabled", "isFullWidth", "isInvalid", "isMulti", "isNative", "menuShouldBlockScroll", "menuPlacement", "onChange", "options", "placeholder", "closeMenuOnSelect", "width"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useCallback, useEffect, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { StyledSelect, StyledSelectAsync, StyledSelectCreatable, StyledSelectCreatableAsync, StyledSelectNative, ClearIndicator, ClearIndicatorStyles, ControlStyles, DropdownIndicator, IndicatorsContainerStyles, IndicatorSeparator, MenuStyles, MenuListStyles, MenuListBlockScrollStyles, MenuPortalStyles, MultiValueContainer, MultiValueContainerStyles, MultiValueLabelStyles, Option, OptionStyles, PlaceholderStyles, SelectContainerStyles, SingleValue, SingleValueStyles, GroupHeadingStyles, ValueContainerStyles } from './Select.styles';
import { jsx as _jsx } from "react/jsx-runtime";
var Select = forwardRef(function (_ref, ref) {
  var _cx;

  var id = _ref.id,
      customClassName = _ref.className,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      allOption = _ref.allOption,
      allSelectedMessage = _ref.allSelectedMessage,
      customLabelKey = _ref.customLabelKey,
      customValueKey = _ref.customValueKey,
      someSelectedMessage = _ref.someSelectedMessage,
      _ref$hasTruncation = _ref.hasTruncation,
      hasTruncation = _ref$hasTruncation === void 0 ? false : _ref$hasTruncation,
      _ref$hideSelectedOpti = _ref.hideSelectedOptions,
      hideSelectedOptions = _ref$hideSelectedOpti === void 0 ? false : _ref$hideSelectedOpti,
      isAsync = _ref.isAsync,
      isCreatable = _ref.isCreatable,
      isDisabled = _ref.isDisabled,
      isFullWidth = _ref.isFullWidth,
      isInvalid = _ref.isInvalid,
      _ref$isMulti = _ref.isMulti,
      isMulti = _ref$isMulti === void 0 ? false : _ref$isMulti,
      isNative = _ref.isNative,
      _ref$menuShouldBlockS = _ref.menuShouldBlockScroll,
      menuShouldBlockScroll = _ref$menuShouldBlockS === void 0 ? false : _ref$menuShouldBlockS,
      _ref$menuPlacement = _ref.menuPlacement,
      menuPlacement = _ref$menuPlacement === void 0 ? 'auto' : _ref$menuPlacement,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {
    return null;
  } : _ref$onChange,
      initialOptions = _ref.options,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Please select' : _ref$placeholder,
      _ref$closeMenuOnSelec = _ref.closeMenuOnSelect,
      closeMenuOnSelect = _ref$closeMenuOnSelec === void 0 ? isMulti ? false : true : _ref$closeMenuOnSelec,
      width = _ref.width,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-select"), true), _defineProperty(_cx, "".concat(prefix, "-select--disabled"), isDisabled), _defineProperty(_cx, "".concat(prefix, "-select--fullwidth"), isFullWidth), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var components = {
    ClearIndicator: ClearIndicator,
    DropdownIndicator: DropdownIndicator,
    IndicatorSeparator: IndicatorSeparator,
    MultiValueContainer: MultiValueContainer,
    Option: Option,
    SingleValue: SingleValue
  };
  var styles = {
    clearIndicator: ClearIndicatorStyles,
    container: SelectContainerStyles,
    control: ControlStyles,
    indicatorsContainer: IndicatorsContainerStyles,
    menu: MenuStyles,
    menuList: menuShouldBlockScroll ? MenuListBlockScrollStyles : MenuListStyles,
    menuPortal: MenuPortalStyles,
    groupHeading: GroupHeadingStyles,
    multiValue: MultiValueContainerStyles,
    multiValueLabel: MultiValueLabelStyles,
    option: OptionStyles,
    placeholder: PlaceholderStyles,
    singleValue: SingleValueStyles,
    valueContainer: ValueContainerStyles
  };
  var valueKey = customValueKey !== null && customValueKey !== void 0 ? customValueKey : 'value';

  var _useState = useState(function () {
    if (Array.isArray(initialOptions) && initialOptions.length > 0) {
      return allOption ? [allOption].concat(_toConsumableArray(initialOptions)) : _toConsumableArray(initialOptions);
    } else {
      return [];
    }
  }),
      _useState2 = _slicedToArray(_useState, 2),
      options = _useState2[0],
      setOptions = _useState2[1];

  useEffect(function () {
    setOptions(function () {
      if (Array.isArray(initialOptions) && initialOptions.length > 0) {
        return allOption ? [allOption].concat(_toConsumableArray(initialOptions)) : _toConsumableArray(initialOptions);
      } else {
        return [];
      }
    });
  }, [allOption, initialOptions]);
  var getSelectableOptionsCount = useCallback(function () {
    var result = [];

    if (options.length > 0) {
      options.forEach(function (node) {
        if (node !== null && node !== void 0 && node.options) {
          node.options.forEach(function (node) {
            return result.push(node);
          });
        } else {
          result.push(node);
        }
      });
    }

    var selectableOptions = result.filter(function (option) {
      return !(option !== null && option !== void 0 && option.isDisabled) && option[valueKey] !== (allOption === null || allOption === void 0 ? void 0 : allOption[valueKey]);
    });
    return selectableOptions.length;
  }, [allOption, options, valueKey]);

  var _useState3 = useState(getSelectableOptionsCount()),
      _useState4 = _slicedToArray(_useState3, 2),
      selectableOptionsCount = _useState4[0],
      setSelectableOptionsCount = _useState4[1];

  useEffect(function () {
    setSelectableOptionsCount(getSelectableOptionsCount());
  }, [getSelectableOptionsCount]);

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      userCreatedOptions = _useState6[0],
      setUserCreatedOptions = _useState6[1];

  useEffect(function () {
    if (userCreatedOptions !== null) {
      setOptions(userCreatedOptions);
    }
  }, [allOption, initialOptions, userCreatedOptions]);

  var handleChange = function handleChange(selected, event) {
    var _event$option;

    var _selected = selected;
    var hasSelectAll = allOption !== null && allOption !== void 0 && allOption[valueKey] ? true : false;
    var isToogleSelectAll = hasSelectAll && (event === null || event === void 0 ? void 0 : (_event$option = event.option) === null || _event$option === void 0 ? void 0 : _event$option[valueKey]) === (allOption === null || allOption === void 0 ? void 0 : allOption[valueKey]);

    if (isMulti && isCreatable) {
      var newUserOption = selected.filter(function (option) {
        return option.__isNew__ === true;
      });
      var newOptions = new Set([].concat(_toConsumableArray(options), _toConsumableArray(newUserOption)));
      setUserCreatedOptions(_toConsumableArray(Array.from(newOptions)));
    }

    if (isToogleSelectAll) {
      if (event.action === 'select-option') {
        var result = [];
        options.forEach(function (node) {
          if (node !== null && node !== void 0 && node.options) {
            node.options.forEach(function (node) {
              return result.push(node);
            });
          } else {
            result.push(node);
          }
        });
        _selected = result.filter(function (option) {
          return !(option !== null && option !== void 0 && option.isDisabled);
        });
      }

      if (event.action === 'deselect-option') {
        _selected = [];
      }
    }

    if (!isToogleSelectAll && hasSelectAll) {
      var selectedCount = selected.filter(function (option) {
        return option[valueKey] !== allOption[valueKey];
      }).length;

      if (selectableOptionsCount === selectedCount) {
        _selected = [allOption].concat(_toConsumableArray(selected));
      } else {
        _selected = selected.filter(function (option) {
          return option[valueKey] !== allOption[valueKey];
        });
      }
    }

    return onChange(_selected, event);
  };

  var defaultProps = {
    ref: ref,
    id: id,
    allOption: allOption,
    allSelectedMessage: allSelectedMessage,
    className: className,
    classNamePrefix: "".concat(prefix, "-select"),
    closeMenuOnSelect: closeMenuOnSelect,
    components: components,
    customLabelKey: customLabelKey,
    customValueKey: customValueKey,
    hasTruncation: hasTruncation,
    hideSelectedOptions: hideSelectedOptions,
    isDisabled: isDisabled,
    isFullWidth: isFullWidth,
    isMulti: isMulti,
    isInvalid: isInvalid,
    menuPlacement: menuPlacement,
    menuShouldBlockScroll: menuShouldBlockScroll,
    mode: mode,
    onChange: function onChange(selected, event) {
      return handleChange(selected, event);
    },
    options: options,
    placeholder: placeholder,
    selectableOptionsCount: selectableOptionsCount,
    someSelectedMessage: someSelectedMessage,
    styles: styles,
    width: width
  };
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: isNative ? _jsx(StyledSelectNative, _objectSpread(_objectSpread({
      ref: ref,
      id: id,
      className: className,
      classNamePrefix: "".concat(prefix, "-select"),
      disabled: isDisabled,
      "aria-disabled": isDisabled,
      "aria-invalid": isInvalid,
      closeMenuOnSelect: closeMenuOnSelect,
      menuShouldBlockScroll: menuShouldBlockScroll,
      hideSelectedOptions: hideSelectedOptions,
      options: options,
      onChange: onChange,
      selectableOptionsCount: selectableOptionsCount,
      width: width
    }, rest), {}, {
      children: options && options.map(function (option, index) {
        return _jsx("option", {
          value: option.value,
          disabled: option.isDisabled,
          children: option.label
        }, option.id ? option.id : index);
      })
    })) : isAsync && isCreatable ? _jsx(StyledSelectCreatableAsync, _objectSpread(_objectSpread({}, defaultProps), rest)) : isAsync ? _jsx(StyledSelectAsync, _objectSpread(_objectSpread({}, defaultProps), rest)) : isCreatable ? _jsx(StyledSelectCreatable, _objectSpread(_objectSpread({}, defaultProps), rest)) : _jsx(StyledSelect, _objectSpread(_objectSpread({}, defaultProps), rest))
  });
});
Select.displayName = 'Select';
export default Select;